<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>分红利润报表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="reportRequestBody.selectMonth"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      size="mini"
      @change="selectReportDataMonth"
      value-format="yyyy-MM"
    >
    </el-date-picker>
    <el-select value filterable v-model="selectAreaId"
               v-if="orgLevel == 1"
               placeholder="请选择区域" clearable style="width: 200px;margin-left: 5px"
               size="mini" @change="getArea">
      <el-option
        v-for="item in area"
        :key="item.id"
        :label="item.orgName"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="selectOrgId" clearable value
               v-if="orgLevel < 3"
               filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-button size="mini" @click="loadSalaryData">查询</el-button>
    <el-table height="600px" :data="profitList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              show-summary
              class="table-fixed">
      <el-table-column
        align="center"
        prop="areaName"
        width="100"
        label="区域名称"
        v-if="orgLevel == 1"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        width="180"
        label="门店名称"
        v-if="orgLevel <= 2"
      >
      </el-table-column>
        <el-table-column
          align="center"
          prop="reportYearMonth"
          width="100"
          label="月份">
        </el-table-column>
        <el-table-column
          align="center"
          prop="yeji"
          width="150"
          label="业绩">
        </el-table-column>
        <el-table-column
          align="center"
          prop="huokuan"
          width="150"
          label="货款">
        </el-table-column>
        <el-table-column
          align="center"
          prop="caiwufeiyong"
          width="150"
          label="财务费用">
        </el-table-column>
        <el-table-column
          align="center"
          prop="gongzi"
          width="150"
          label="工资">
        </el-table-column>
        <el-table-column
          align="center"
          prop="jinglirun"
          width="150"
          :default-sort="{ order: 'descending' }" sortable
          label="净利润">
        </el-table-column>
        <el-table-column
        v-for="(item, index) in tableTitle"
        align="center"
        :key="item.costId"
        :prop="item.costEnName"
        width="280"
        :render-header="(h, obj) => renderHeader(h, obj, item.costCnName)"
        >
        </el-table-column>
      <el-table-column
        align="center"
        prop="zhichu"
        width="150"
        label="营业支出">
      </el-table-column>
      <el-table-column
        align="center"
        prop="dianmianqitazhichu"
        width="150"
        label="店面其他支出">
      </el-table-column>
      <el-table-column
        align="center"
        prop="dianmianqitashouru"
        width="150"
        label="店面其他收入">
      </el-table-column>
      <el-table-column
        align="center"
        prop="xiaofeidantuifei"
        width="150"
        label="消费单退费">
      </el-table-column>
      </el-table>
      <span class="showFont">
        净利润 = 业绩 - 货款 - 财务费用 - 工资 - 门店社保 - 门店公积金 - 门店房租 - 门店广告费 - 门店管理费 - 店面其他支出 - 支出 - 门店服务费 + 店面其他收入
      </span>
      <br>
      <span class="showFont">
        货款 = 内部采购款 + 内部发放款
      </span>
      <br>
      <span class="showFont">
        工资 = 餐补 + 车补 + 收银补助 + 房补 + 绩效工资 + 其他补助
      </span>
      <br>
      <span class="showFont">
        绩效工资 = 足科提成 + 团购提成 + 按摩提成 + 修复及矫正提成 + 华连生产品提成 + 洁沃产品提成 + 贝尔产品提成 + 会员卡充值提成 - 消费单退费会员提成 - 消费单退费现金提成
      </span>
      <br>
      <span class="showFont">
        店面其他收入 = 退费优惠 + 收入 + 门店其他收入
      </span>
      <span class="showFont">
        店面其他支出 = 门店其他支出 + 门店保险 + 员工体检费 + 培训费
      </span>
      <br>
      <span class="showFont">
        财务费用 = 口碑团购 * 0.04 + （消费Pos机 + 支付宝 + 美团支付 + 微信小程序 + 储值Pos机 + 储值小程序）* 0.01
      </span>
  </div>
</template>

<script>
export default {
  data(){
    return{
      profitDate:'',
      authName:'',
      groupValue:'',
      area:[],
      shop:[],
      queryInfo:{
        startDate:'',
        endDate:'',
        orgId:''
      },
      reportRequestBody:{
        startMonth:'',
        endMonth:'',
        shopId:'',
        areaId:'',
        orgId:'',
        selectMonth:'',
        userId:0,
        orgLevel:''
      },
      profitList:[],
      tableTitle:[],
      selectAreaId:'',
      selectOrgId:'',
      selectUserId:'',
    }
  },
  methods:{
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
      }
    },
    async loadSalaryData(){
      this.reportRequestBody.startMonth = this.getCurrentMonth();
      this.reportRequestBody.endMonth = this.getCurrentMonth();
      if (this.reportRequestBody.selectMonth !== '' && this.reportRequestBody.selectMonth != null){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/profit/data`, this.reportRequestBody)
      this.profitList = res.data;
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    async loadTableTitle(){
      const {data:res} = await this.$http.get(`/profit/header/orgId/${this.orgId}`)
      this.tableTitle = res.data;
    },
    async getArea(data){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
      this.shop = res.data;
    },
    // 自定义表头
    renderHeader(h, { column, $index }, type) {
      let that = this;
      return h(
        'div', [
          // 列名称
          h('span', column.label),
          // 按钮
          h('span', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: 'margin-left: 5px;height:20px;padding-top: 2px;color:#333',
          }, type)
        ],
      )
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopId = data;
        // const {data:res} = await this.$http.get(`/org/users/${data}`);
        // this.users = res.data;
      } else {
        this.reportRequestBody.shopId = 0;
      }
    },
    async loadGroupShop(){
      const {data:res} = await this.$http.get(`/group-org`,
        { params:{userId: this.userId, groupValue: this.groupValue}});
      this.shop = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authName = window.sessionStorage.getItem('authName');
    this.groupValue = window.sessionStorage.getItem('groupValue');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      if(this.authName === 'group'){
        this.loadGroupShop();
      } else {
        this.loadShop();
      }
    }
    if (this.orgLevel == 3){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.shopId = this.orgId;
    }
    this.loadTableTitle();
    this.loadSalaryData();
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}

.table-fixed{
  /deep/.el-table__body-wrapper {
    height: calc(100% - 55px) !important;
  }
}
.showFont{
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Profit.vue